import Button from "@app/components/button";
import CustomRadio from "@app/components/custom-radio";
import { EWallet } from "@app/constants";
import { Bank } from "@app/types";
import { Images } from "@assets/images";
import clsx from "clsx";

interface StepTwoProps {
  walletIdSelected?: EWallet;
  bankIdSelected?: number;
  banks: Bank[];
  handleBankClick: (bankId?: number) => void;
  handleWalletClick: (walletId?: EWallet) => void;
  handleConfirm: () => void;
}

function StepTwo({
  walletIdSelected,
  bankIdSelected,
  banks,
  handleBankClick,
  handleWalletClick,
  handleConfirm,
}: StepTwoProps) {
  const handleBankItemClick = (bankId: number) => {
    handleBankClick(bankId);
    handleWalletClick(undefined);
  };

  const handleWalletItemClick = (walletId: EWallet) => {
    handleBankClick(undefined);
    handleWalletClick(walletId);
  };

  return (
    <div className="mt-16 w-[398px] mx-auto min-h-[calc(100vh-648px)]">
      <div className="text-lg font-semibold font-[SVN-Gilroy]">
        Chuyển khoản
      </div>
      <div className="mt-3 flex flex-col gap-4">
        {!!banks.length &&
          banks.map((bank) => (
            <div
              key={bank.id}
              className={clsx(
                "bg-[#DFE2E7] px-4 py-4 rounded-lg flex justify-between cursor-pointer border-[2px] border-solid border-transparent",
                {
                  "!border-[#49C172]": bankIdSelected === bank.id,
                }
              )}
              onClick={() => handleBankItemClick(bank.id)}
            >
              <div className="flex gap-[10px]">
                <img className="w-6" src={bank.thumbnail} alt="VCB" />
                <div className="font-[SVN-Gilroy] font-medium">
                  {bank.bankName}
                </div>
              </div>
              <CustomRadio
                checked={bankIdSelected === bank.id}
                outerClassName={clsx({
                  "!border-[#288564]": bankIdSelected === bank.id,
                })}
                innerClassName={clsx({
                  "!bg-[#288564]": bankIdSelected === bank.id,
                })}
              />
            </div>
          ))}
      </div>
      <div className="mt-7">
        <div className="text-lg font-semibold font-[SVN-Gilroy]">
          Ví điện tử
        </div>
        <div className="mt-3 flex flex-col gap-4">
          <div
            className={clsx(
              "bg-[#DFE2E7] px-4 py-4 rounded-lg flex justify-between cursor-pointer border-[2px] border-solid border-transparent",
              {
                "!border-[#49C172]": walletIdSelected === EWallet.MOMO,
              }
            )}
            onClick={() => handleWalletItemClick(EWallet.MOMO)}
          >
            <div className="flex gap-[10px]">
              <img src={Images.Momo.default} width={24} alt="Momo" />
              <div>MoMo</div>
            </div>
            <img src={Images.ArrowRightBlack.default} alt="" />
          </div>
          <div
            className={clsx(
              "bg-[#DFE2E7] px-4 py-4 rounded-lg flex justify-between cursor-pointer border-[2px] border-solid border-transparent",
              {
                "!border-[#49C172]": walletIdSelected === EWallet.ZALO_PAY,
              }
            )}
            onClick={() => handleWalletItemClick(EWallet.ZALO_PAY)}
          >
            <div className="flex gap-[10px]">
              <img src={Images.ZaloPay.default} alt="ZaloPay" />
              <div>ZaloPay</div>
            </div>
            <img src={Images.ArrowRightBlack.default} alt="" />
          </div>
        </div>
      </div>
      <Button
        width="auto"
        className="!w-[398px] mt-14 !h-12 font-bold bg-gradient-to-b from-[#49C172] to-[#288564] !rounded-[24px]"
        label="Xác nhận"
        labelClassName="font-[SVN-Gilroy] text-lg tracking-[0.027px]"
        containerClassName="flex justify-center"
        disabled={!bankIdSelected && !walletIdSelected}
        onClick={handleConfirm}
      />
    </div>
  );
}

export default StepTwo;
